import { render, staticRenderFns } from "./CustomerAddresses.vue?vue&type=template&id=6c12718c&"
import script from "./CustomerAddresses.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddresses.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports